<template>
  <StatusChangeProcedureApplyInput label="休眠"
                                   class="status-change-procedure-apply-dormancy"
                                   v-on="$listeners"
                                   :resolve-form="getApplyInfo">
    <template>
      <slot></slot>
    </template>
    <template #form>
      <el-form size="mini"
               label-width="120px"
               label-suffix="：">
        <el-form-item label="休眠原因">
          <el-input v-model.trim="form.reason"
                    type="text"
                    maxlength="100"
                    placeholder="请填写休眠原因"></el-input>
        </el-form-item>
        <el-form-item label="备注信息">
          <el-input v-model="form.remark"
                    type="textarea"
                    maxlength="200"></el-input>
        </el-form-item>
      </el-form>
    </template>
  </StatusChangeProcedureApplyInput>
</template>

<script>
import StatusChangeProcedureApplyInput from '../input'
export default {
  name: 'StatusChangeProcedureApplyDormancy',
  components: {
    StatusChangeProcedureApplyInput
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      form: {
        reason: '',
        remark: ''
      }
    }
  },
  methods: {
    getApplyInfo () {
      return new Promise((resolve, reject) => {
        if (!this.form.reason) {
          reject(new Error('请填写休眠原因'))
          return
        }
        if (!this.form.remark) {
          this.$confirm('未填写备注信息，确认继续吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            resolve(this.resolveApply(this.form))
          }).catch(() => {})
        } else {
          resolve(this.resolveApply(this.form))
        }
      })
    },
    resolveApply (form) {
      return {
        url: '/workspace/manager/status/change/procedure/dormancy/submitApply',
        data: this.$qs.stringify(this.$extend({
          postId: this.studentId
        }, form, this.extraParams))
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          if (typeof this.form[key] === 'string') {
            this.form[key] = val[key] || ''
          } else {
            this.form[key] = val[key]
          }
        })
      }
    }
  }
}
</script>
